<template>
  <v-container class="pa-0">
    <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
      <page-header-title :title="$t('users.title')"></page-header-title>

      <v-spacer></v-spacer>

      <v-form ref="form" @submit.prevent="filter" class="mt-8 d-none d-sm-flex">
        <v-container grid-list-md>
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field
                :label="$t('global.search')"
                v-model="search_params.any"
                @keydown="checkKeyPress"
                autocomplete="new-password"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>

      <router-link :to="BACKEND_URL + '/users/create'" v-if="$can('user-create')">
        <action-button type="new" />
      </router-link>
    </v-app-bar>

    <v-card>
      <v-card-text>
        <v-flex md12>
          <v-data-table
            :headers="headers"
            :items="users"
            :items-per-page="users.length"
            :options.sync="pagination"
            :footer-props="{
              showFirstLastPage: true,
              'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
              'items-per-page-all-text': $t('global.items_per_page_all_text'),
              'items-per-page-text': $t('global.items_per_page_text'),
              'page-text': $t('global.page_text')
            }"
            :server-items-length="total"
            :loading="show_loading"
            :loading-text="$t('global.loading_text')"
            :no-data-text="$t('global.no_data_text')"
            :no-results-text="$t('global.no_results_text')"
            :must-sort="true"
          >
            <template v-slot:item.first_name="{ item }">
              {{ item.person.first_name }}
            </template>

            <template v-slot:item.last_name="{ item }">
              {{ item.person.last_name }}
            </template>

            <template v-slot:item.status="{ item }">
              {{ $dd_user_status(item.status) }}
            </template>

            <template v-slot:item.roles="{ item }">
              {{ item.roles.map((i) => i.name).join(", ") }}
            </template>
            
            <template v-slot:item.company_names="{ item }">
              {{ item.company_names.map((i) => i).join(", ") }}
            </template>

            <template v-slot:item.actions="{ item }">
              <router-link :to="{ path: BACKEND_URL + '/users/edit/' + item.id, props: { id: item.id } }" v-if="$can('user-access')">
                <action-button small type="edit" :icon_only="true" />
              </router-link>

              <action-button
                small
                type="delete"
                @click="del(item.id)"
                :icon_only="true"
                v-if="$can('user-delete')"
                :disabled="
                  Boolean(admin_count < 2 && item.roles.find((i) => i.slug == 'organisation-admin')) || Boolean(loggedinuser.id == item.id)
                "
              />
            </template>
          </v-data-table>
        </v-flex>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "UserList",

  data() {
    return {
      url: "",
      users: [],
      admin_count: 0,
      total: 0,
      show_loading: false,
      show_filter: false,
      refresh: false,
      pagination: {
        page: this.$getLocalStorage("__userListPage", "page"),
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["first_name"],
        sortDesc: [false]
      },
      search_params: {
        any: ""
      }
    }
  },

  watch: {
    refresh: {
      handler() {
        if (this.refresh) {
          localStorage.setItem("__userListSearchParams", JSON.stringify(this.search_params))
          this.list()
        }
      }
    },
    pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) {
          if (
            _.has(newVal, "sortBy") &&
            _.has(newVal, "sortDesc") &&
            _.has(oldVal, "sortBy") &&
            _.has(oldVal, "sortDesc") &&
            (!_.isEqual(newVal.sortBy, oldVal.sortBy) || !_.isEqual(newVal.sortDesc, oldVal.sortDesc))
          ) {
            let obj = {
              sortBy: this.pagination.sortBy,
              sortDesc: this.pagination.sortDesc
            }
            localStorage.setItem("__userListSort", JSON.stringify(obj))
          }

          if (_.has(newVal, "page") && !_.isEqual(newVal.page, oldVal.page)) {
            localStorage.setItem("__userListPage", newVal.page)
          }

          this.refresh = true
        }
      }
    }
  },

  computed: {
    headers: {
      get() {
        return [
          { text: this.$t("users.first_name"), value: "first_name" },
          { text: this.$t("users.last_name"), value: "last_name" },
          { text: this.$t("users.email"), value: "email" },
          { text: this.$t("users.status"), value: "status" },
          { text: this.$t("enrolments.title_org"), value: "company_names" },
          { text: this.$t("roles.title"), value: "roles", width: "20%" },
          { text: this.$t("global.actions"), value: "actions", width: "20%", align: "end", sortable: false }
        ]
      }
    },
    loggedinuser: {
      get() {
        return this.$store.getters["auth/user"]
      }
    }
  },

  mounted() {
    this.url = this.API_URL + "users"
    if (localStorage.getItem("__userListSearchParams")) {
      this.search_params = JSON.parse(localStorage.getItem("__userListSearchParams"))
    }
  },

  methods: {
    list(url) {
      this.show_loading = true

      let localSort = localStorage.getItem("__userListSort")
      if (localSort !== null) {
        localSort = JSON.parse(localSort)
        this.pagination.sortBy = localSort.sortBy
        this.pagination.sortDesc = localSort.sortDesc
      }

      let { sortBy, descending, page, itemsPerPage } = this.pagination
      let query = this.$queryString(this.pagination, this.search_params)

      axios
        .get(this.url + "?resourcetype=user-list&" + query)
        .then((res) => {
          this.users = res.data.data
          this.total = res.data.meta.total
          this.refresh = false
          this.show_loading = false

          this.pagination.page = res.data.meta.current_page
          this.pagination.itemsPerPage = Number(res.data.meta.per_page)

          this.admin_count = this.users.filter((i) => {
            return i.roles.find((i) => i.slug == "organisation-admin")
          }).length
        })
        .catch((err) => console.log(err))
    },

    filter(target) {
      this.pagination.page = 1
      this.refresh = true
    },

    reset() {
      this.$refs.form.reset()
      this.pagination.page = 1
      this.refresh = true
    },

    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "user/" + id)
            .then(() => {
              this.refresh = true
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },

    checkKeyPress(e) {
      if (e.key == "Enter") {
        this.filter()
      }
    }
  }
}
</script>

<style scoped></style>
